import { LocaleToTranslationSource } from '@wix/answers-lib';

const isNode = typeof window === 'undefined';

const w: any = isNode ? global : window;

const fallbackLanguage = 'en';

export const contentEditorTranslate = (key: string, lang: string, params: any = {}) => {
	const contentEditorTranslations = w.___answersContentEditorTranslations;
	const keys = contentEditorTranslations[lang] || contentEditorTranslations[fallbackLanguage] || {};
	const val =  keys[key] || key;
	return Object.keys(params).reduce((prev, paramName) => {
		const param = params[paramName];
		return prev.replace(`{{${paramName}}}`, param);
	}, val);
};

export const getGlobalTranslateSource = (): LocaleToTranslationSource => {
	try {
		const win: any = window || {};
		const globalSource: LocaleToTranslationSource = win.___answersTranslations || {}; // one day, one day my son, we'll get rid of
		return globalSource;
	} catch (e) {
		return {en: {}};
	}
};
